import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { MainNavService} from "../mainNav.service";
import {CurrentRouteService} from "../currentRoute.service";

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.css']
})
export class UserPreferencesComponent implements OnInit {

  constructor( private route: ActivatedRoute,
               private router: Router,
               private mainnavService: MainNavService,
               private currentrouteService: CurrentRouteService) { }

  ngOnInit(): void {
    //lets notify mainnav that we are in user settings
    let query_parms = this.route.snapshot.queryParamMap;
    let is_user_settings = query_parms.get('is_user_settings');
    let is_account_route = query_parms.get('is_account_route');
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.mainnavService.announceMainNav({is_user_settings: is_user_settings,is_account_route: is_account_route})
     console.log(query_parms)
  } //end ngOnInit

} //end class
